import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import Amenity from './../models/Amenity';

const initialState = {
    isFetching: false,
    isFetched: false,
    isSubmit: false,
    isGetItem: false,
    amenities: [],
    detail: {
        amenity: new Amenity()
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.AMENITY_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.AMENITY_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                amenities: action.amenities.result,
            };
        case Types.AMENITY_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, amenities: [] };
        case Types.AMENITY_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail, isSubmit: true, isGetItem: true };
        case Types.AMENITY_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, 
                isFetched: true,
                isSubmit: false,
                detail: {
                    amenity: action.amenity
                }
            };
        case Types.AMENITY_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.AMENITY_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.AMENITY_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.AMENITY_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.AMENITY_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.AMENITY_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.AMENITY_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.AMENITY_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.AMENITY_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.AMENITY_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.AMENITY_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true, isSubmit: false, isGetItem: false };
        default: 
            return state
    }
}
